import { Box, BoxProps } from '@chakra-ui/react'
import * as React from 'react'

const VisualizerLazy = React.lazy(() => import('./Visualizer'))

export type VisualizerSuspenseProps = BoxProps & {}

const VisualizerSuspense: React.FC<VisualizerSuspenseProps> = ({ ...others }) => {
  const isSSR = typeof window === 'undefined'

  return (
    <>
      <Box pos="fixed" top={[0, '120px']} left="0" right="0" bottom="0" {...others}>
        {!isSSR && (
          <React.Suspense fallback={<div />}>
            <VisualizerLazy />
          </React.Suspense>
        )}
      </Box>
    </>
  )
}

export default VisualizerSuspense
